import type { MutableRefObject } from 'react';
import { createContext, useContext } from 'react';

import * as language from 'pkg/i18n/language';
import * as ls from 'pkg/local_storage';

import { getDefaultDrawerState } from 'components/application/drawer';

export interface ApplicationState {
	scrollElement: MutableRefObject<any>;
	// state to see if we have a action bar in the view, we set this to true in the ActionBar components
	hasActionBar: boolean;
	hasPagination: boolean;
	keyboardOpen: boolean;
	language: string;
	collapsedDrawer: boolean;
	darkMode: boolean;

	setLanguage?: (lang: string) => void;
	setCollapsedDrawer?: (collapsed: boolean) => void;
	setScrollElement?: (scrollItem: MutableRefObject<any>) => void;
	setHasActionBar?: (value: boolean) => void;
	setHasPagination?: (value: boolean) => void;
	setDarkMode?: (value: boolean) => void;
}

export const initialApplicationState: ApplicationState = {
	scrollElement: null,
	hasActionBar: false,
	hasPagination: false,
	keyboardOpen: false,
	darkMode: ls.getItem(ls.LocalStorageKeys.DarkMode) === 'true',
	collapsedDrawer: getDefaultDrawerState(),
	language: language.get(),
};

export const ApplicationStateContext = createContext<ApplicationState>(
	initialApplicationState
);

export function useAppState(): ApplicationState {
	const ctx = useContext(ApplicationStateContext);
	return ctx;
}
